import { render, staticRenderFns } from "./WowClassicRaidGuidesComponent.vue?vue&type=template&id=2b6fb003&"
import script from "./WowClassicRaidGuidesComponent.vue?vue&type=script&lang=js&"
export * from "./WowClassicRaidGuidesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports